"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAdvertising = void 0;
const react_1 = require("react");
const AdvertisingContext_1 = require("./AdvertisingContext");
const useAdvertising = () => {
    const context = (0, react_1.useContext)(AdvertisingContext_1.AdvertisingContext);
    if (!context) {
        throw new Error('useAdvertising must be used within an AdvertisingProvider');
    }
    return context;
};
exports.useAdvertising = useAdvertising;
